module.exports = __webpack_public_path__ + "img/folder-open.6459bd1d.svg";